module.exports = __webpack_public_path__ + "img/Screenshot_3.713ca82f.png";